module.exports = __webpack_public_path__ + "img/main_bose.f2478e26.jpg";